var utils = require('util');
var View = require('./View');
var CaseWorldUserInteraction = require('./CaseWorldUserInteraction');
var CompositionElementView = require('./CompositionElementView');
var PartView = require('./PartView');
var HeightPartView = require('./HeightPartView');
var DepthPartView = require('./DepthPartView');
var LengthPartView = require('./LengthPartView');
var UpperPartView = require('./UpperPartView');
var PartCache = require('../Models/PartCache');

var STAGE_HEIGHT_OFFSET = 22;

var CaseWorldView = module.exports = function(model){
    this.scene;
    this.camera;
    this.renderer;

    this.elementViews = {part: []};

    this.oldElementViews = [];

    this.domElement;

    this.model = model;

    this.stage;

    this.rolls = this.model._hasRolls;
    this.FIELD_OF_VIEW = 40;
    this.ASPECT_RATIO = 1.471;
    this.interactionHandler;
    this.initView();

    this.frontLight;
    this.backLight;
    this.topLight;

    this.startAnimationDone = false;

    this.cache = new PartCache();

};

utils.inherits(CaseWorldView, View);



CaseWorldView.prototype.createWorld = function($inElement){
    var that = this;

    this.initRenderer();

    this.initSceneWithCamera();


    if(Detector.webgl) {
        this.initLight();
    }

    this.initCaseElements();

    this.domElement = this.renderer.domElement;

    $inElement.append(this.renderer.domElement);

    // default values... needed for threejs to calcualte sizes.. "real" sizing is done later in css
    $(this.domElement).css({height: '367px', width: '540px'});

    this.initStage();

    this.once('WorldCreated', function() {
        that.interactionHandler = new CaseWorldUserInteraction(this);
        that.interactionHandler.assignInteractions();

        if(Detector.webgl) {
            that.interactionHandler.once('fullCameraRotationDone', function(){that.startAnimationDone= true;});

            that.interactionHandler.cameraFullRotation();
        }else {
            that.startAnimationDone= true;
        }

    });


    this.clock = new THREE.Clock();
};

CaseWorldView.prototype.render = function(){
    var that = this;

    var renderId = null;

    function render() {
        TWEEN.update();
        if(Detector.webgl) {
            that.interactionHandler.updateCamera(that.clock.getDelta());
        }
        cancelAnimationFrame(renderId);
        renderId = requestAnimationFrame(render);
        that.renderer.render(that.scene, that.camera);
    }

    window.onblur = function() {
        that.emit('cancelRendering');
    };

    that.on('cancelRendering', function() {
        // render last time or single updates would be cancelled
        render();
        setTimeout(function() {
            if(renderId !== null && that.startAnimationDone === true) {
                cancelAnimationFrame(renderId);

                renderId = null;
            }
        }, 50);
    });

    that.on('beginRendering', function() {
        if(renderId === null) {
            render();
        }
    });

    render();

    that.emit('renderingInitialized');
};

CaseWorldView.prototype.initSceneWithCamera = function(){
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(this.FIELD_OF_VIEW, this.ASPECT_RATIO, 0.1, 10000);
    //this.cameera.position.set(1250, 1000, 1800).multiplyScalar(0.5);
    if(Detector.webgl){
        this.camera.position.set(700, 500, 1000);
    }else {
        this.camera.position.set(0, 0, 1800);
    }
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    this.scene.add(this.camera);

};

CaseWorldView.prototype.initStage = function() {
    var that = this;

    var shadow = THREE.ImageUtils.loadTexture(this.cache.getBasePath() + 'images/shadow.png');
    var material = new THREE.MeshPhongMaterial({map: shadow, color: '#ffffff', shading: THREE.NoShading, shininess: 90, reflectivity: 1, emissive: '#ffffff'});
    material.opacity = 0.60;

    var plane = new THREE.PlaneGeometry(2*that.model._length, 2*that.model._depth);

    that.stage = new THREE.Mesh(plane, material);
    that.stage.rotation.x = -0.5*Math.PI;


    that._positionStage();
    that.scene.add(that.stage);
};

CaseWorldView.prototype._positionStage = function() {
    var that = this;
    var rollsOffset = 0;

    if(that.rolls === 'WHEEL') {
        rollsOffset = 130;
    }else if(that.rolls === 'STAND') {
        rollsOffset = 0;
    }else if (that.rolls === 'TROLLEY' || that.rolls === 'ACCESSORY_PULLOUT_HANDLE') {
        rollsOffset = 20;
    }else  if(that.rolls === 'CORNER_WHEEL') {
        rollsOffset = 20;
    }

    that.stage.position.set(0, -that.model._body._height/2 - STAGE_HEIGHT_OFFSET - rollsOffset, 0);
};

CaseWorldView.prototype._setStageDimensions = function() {
    var that = this;
    that.scene.remove(that.stage);

    that.stage = new THREE.Mesh(new THREE.PlaneGeometry((2*that.model._length), 2*that.model._depth), that.stage.material);
    that.stage.rotation.x = -0.5*Math.PI;
    that.scene.add(that.stage);
};

CaseWorldView.prototype.updateStage = function() {
    var that = this;
    that._setStageDimensions();

    that._positionStage();
};


CaseWorldView.prototype.initCaseElements = function(lateAdding) {
    var that = this;

    var partView = that.elementViews['part'];
    var bodyView = that.elementViews['_body'];
    var capView = that.elementViews['_cap'];
    var capView2 = that.elementViews['_capTwo'];
    var loadedParts = partView.length === 0;
    var loadedBody = false;
    var loadedCap = false;
    var scalePanelOffset = that.model._scalePanelOffset;

    partView.forEach(function(view, index2){
        view.setScalePanelOffset(scalePanelOffset);

        view.once('3DModelLoaded', function(){
            if(index2 === (partView.length - 1)) {
                loadedParts = true;
            }

            that.cache.setCache(view.getModel().file, view.getOriginal3DModel());

            modelLoadedHandler(view, loadedParts, loadedBody, loadedCap);
        });

        view.loadModel3D(that.cache.getCache(view.getModel().file));
    });

    bodyView.once('3DCompositionModelLoaded', function(){
        loadedBody = true;
        modelLoadedHandler(bodyView, loadedParts, loadedBody, loadedCap);
    });

    bodyView.setScalePanelOffset(scalePanelOffset);
    bodyView.loadModel3D();

    if(capView) {
        capView.once('3DCompositionModelLoaded', function(){
            loadedCap = true;
            modelLoadedHandler(capView, loadedParts, loadedBody, loadedCap);
        });

        capView.setScalePanelOffset(scalePanelOffset);
        capView.loadModel3D();
    }


    if(capView2) {
        capView2.setScalePanelOffset(scalePanelOffset);
        capView2.once('3DCompositionModelLoaded', function(){

            modelLoadedHandler(capView2, loadedParts, loadedBody, loadedCap);
        });
        capView2.loadModel3D();
    }


    function modelLoadedHandler(elementView, loadedParts, loadedBody, loadedCap) {
        var model3D = elementView.getModel3D();

        if(model3D) {
            if(lateAdding) {
                that.once('WorldCreated', function() {
                    that.scene.add(model3D);
                });
            }else {
                that.scene.add(model3D);
            }
        }

        if(loadedParts && loadedBody && (!capView || loadedCap)){
            that.clearOldElementViews();
            that.emit('WorldCreated');
        }
    }
};

CaseWorldView.prototype.initRenderer = function(){
    if (Detector.webgl) {
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            precision: 'highp',
            preserveDrawingBuffer: true,
            sortObjects: false
        });
    } else {
        this.renderer = new THREE.CanvasRenderer({

        });
    }
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setClearColor(0xffffff);
};

CaseWorldView.prototype.initLight = function() {
    var that = this;

    that.scene.add(new THREE.AmbientLight('#ffffff'));
    var spotLight = new THREE.PointLight('#ffffff');
    spotLight.angle = Math.PI/2;
    spotLight.intensity = 2;
    //pointLight.position.set(2200, 1050, 1500);
    var scalar = 1;
    spotLight.position.set(-3000, 0, 3000).multiplyScalar(scalar);
    spotLight.lookAt(that.scene.position);
    this.frontLight = spotLight;
    that.scene.add(this.frontLight);

    var pointLight = new THREE.PointLight('#ffffff');
    pointLight.angle = Math.PI/2;
    pointLight.intensity = 2;
    //pointLight.position.set(-2200, 1050, -1500);
    pointLight.position.set(3000, 0, -3000).multiplyScalar(scalar);
    pointLight.lookAt(that.scene.position);
    this.backLight = pointLight;
    that.scene.add(this.backLight);

    var pointLight = new THREE.PointLight('#ffffff');
    pointLight.position.set(0, 3000, 0);
    pointLight.intensity = 1.0;
    pointLight.lookAt(that.scene.position);
    this.topLight = pointLight;
    that.scene.add(this.topLight);

};

CaseWorldView.prototype.addElementView = function(elementView, type) {
    var that = this;

    if(type) {
        that.elementViews[type] = elementView;
    }else {
        that.elementViews['part'].push(elementView);
    }

};

CaseWorldView.prototype.addPartView = function(partView, type) {
    var that = this;

    partView.loadModel3D();


    if(type) {
        that.elementViews[type].addPartView(partView);
    }else {
        that.elementViews['part'].push(partView);
    }
};


CaseWorldView.prototype.bufferElementViews = function() {
    this.oldElementViews.push(this.elementViews);
    this.elementViews = {part: []};
};

CaseWorldView.prototype.clearOldElementViews = function() {
    var that = this;

    that.oldElementViews.forEach(function(oldElementView){
        Object.keys(oldElementView).forEach(function(part) {
            var view = oldElementView[part];
            if(Array.isArray(view)){
                view.forEach(function(oldView) {
                    var model3D = oldView.getModel3D();
                    model3D.scale.set(1.1, 1.1, 1.1);
                    that.scene.remove(model3D);
                });
            }else {
                var model3D2 = view.getModel3D();
                model3D2.scale.set(1.1, 1.1, 1.1);
                that.scene.remove(model3D2);
            }
        })
    });

    that.oldElementViews = [];
};

CaseWorldView.prototype.scaleHeight = function(globalScale, change) {
    var that = this;
    var keepBodyHeight = that.model._keepBodyHeight;
    var keepCapBodyRation = that.model._keepCapBodyRatio;
    that.iterateElementViews(function(view, partType) {
        if(partType === '_cap') {
            view.scaleHeight(globalScale, change, keepCapBodyRation, true, keepBodyHeight);
        }else {

            view.scaleHeight(globalScale, change, keepCapBodyRation, null, keepBodyHeight);
        }

    });

    that.updateStage();
};

CaseWorldView.prototype.updateHeight = function(newHeight) {
    var that = this;
    that.model._height = newHeight;

    if(that.model._keepCapBodyRatio) {
        var ratio = that._getCapBodyRatio();
        var newCapHeight = (newHeight)/(ratio + 1);
        var newBodyHeight = newHeight*(1- (1/(ratio + 1)));
        that.elementViews['_body'].updateHeight(newBodyHeight);
        that.elementViews['_cap'].updateHeight(newCapHeight);
    }else if(that.model._keepCapHeight) {
        var capHeight = that.elementViews._cap.getModel()._height;
        var newBodyHeight = newHeight - capHeight;
        var oldBodyHeight = that.elementViews._body.getModel()._height;

        that.elementViews._body.updateHeight(newBodyHeight);

        that.elementViews.part.forEach(function(partView) {
            partView.updateHeight(newBodyHeight);
        });

        return newBodyHeight/oldBodyHeight;
    }else if(that.model._keepBodyHeight) {
        var bodyHeight = that.elementViews._body.getModel()._height;

        var newCapHeight = newHeight - bodyHeight;

        var oldCapHeight = that.elementViews._cap.getModel()._height;

        that.elementViews._cap.updateHeight(newCapHeight);

        return newCapHeight/oldCapHeight;
    }else if(that.model._isDoubleDoorRack) {

        that.elementViews._body.updateHeight(newHeight);

        that.elementViews.part.forEach(function(partView) {
            partView.updateHeight(newHeight);
        });

        if(that.elementViews._cap){
            that.elementViews._cap.updateHeight(newHeight);
        }

        if(that.elementViews._capTwo) {
            that.elementViews._capTwo.updateHeight(newHeight);
        }


        return null;
    }

    return null;

};

CaseWorldView.prototype.updateLength = function(newLength) {
    var that = this;

    that.model._length = newLength;

    that.iterateElementViews(function(view) {
        view.updateLength(newLength);
    });
};

CaseWorldView.prototype.scaleLength = function(globalScale, change) {
    var that = this;

    that.iterateElementViews(function(view) {
        view.scaleLength(globalScale, change);
    });


    that.updateStage();
};

CaseWorldView.prototype.updateDepth = function(newDepth) {
    var that = this;

    that.model._depth = newDepth;

    that.iterateElementViews(function(view) {
        view.updateDepth(newDepth);
    });
};

CaseWorldView.prototype.scaleDepth = function(globalScale, change) {
    var that = this;

    that.iterateElementViews(function(view) {
        view.scaleDepth(globalScale, change);
    });

    that.updateStage();
};



CaseWorldView.prototype._getCapBodyRatio = function() {
    var that = this;

    var bodyHeight = that.elementViews._body.getModel()._height;
    var capHeight = that.elementViews._cap.getModel()._height;

    return bodyHeight/capHeight;
};

CaseWorldView.prototype.getModel = function() {
    return this.model;
};

CaseWorldView.prototype.setModel = function(model) {
    this.rolls = model._hasRolls;
    this.model = model;


    return this;
};

CaseWorldView.prototype.getCamera = function() {
    return this.camera;
};

CaseWorldView.prototype.getDomElement = function() {
    return this.domElement;
};

CaseWorldView.prototype.getScene = function()  {
    return this.scene;
};

CaseWorldView.prototype.iterateElementViews = function(callback) {
    var that = this;
    Object.keys(that.elementViews).forEach(function(partType) {
        if(partType === 'part') {
            that.elementViews[partType].forEach(function(view, index) {
                callback(view, partType, index);
            });
        }else {
            callback(that.elementViews[partType], partType);
        }
    });
};


CaseWorldView.prototype.activateRolls = function(flag) {
    var that = this;

    that.rolls = flag;
};

CaseWorldView.prototype.changeElement = function(partId, category, file, textureFile, normalMaps, on) {
    var that = this;

    if(on) {
        that.elementViews[on].getPartViews().forEach(function(view, index) {
            checkAndUpdateElement(view, that.elementViews._cap, index);
        });

        return;
    }

    that.iterateElementViews(function(view, partType, index) {
        if(view instanceof CompositionElementView) {
            var partViews = view.getPartViews();
            partViews.forEach(function(partView, index2) {
               checkAndUpdateElement(partView, view, index2);
            });
        }else {
            checkAndUpdateElement(view, that, index);
        }


    });

    function checkAndUpdateElement(view, viewContainer, index){
        var model = view.getModel();
        var newPartView;
        if(model.category === category) {
            model.file = file;
            model.textureFile = textureFile;
            model.id = partId;
            model.normalMaps = normalMaps;

            if(view instanceof HeightPartView) {
                newPartView = new HeightPartView(model, view.getParentHeight(), view.getParentLength(), view.getParentDepth());
            }else if(view instanceof LengthPartView) {
                newPartView = new LengthPartView(model, view.getParentHeight(), view.getParentLength(), view.getParentDepth());
            }else if(view instanceof DepthPartView) {
                newPartView = new DepthPartView(model, view.getParentHeight(), view.getParentLength(), view.getParentDepth());
            }else if(view instanceof  UpperPartView) {
                newPartView = new UpperPartView(model, view.getParentHeight(), view.getParentLength(), view.getParentDepth());
            }else {
                newPartView = new PartView(model, view.getParentHeight(), view.getParentLength(), view.getParentDepth());
            }

            newPartView.setScalePanelOffset(that.model._scalePanelOffset);

            newPartView.once('3DModelLoaded', function() {
                that.cache.setCache(file, newPartView.getOriginal3DModel());
                viewContainer.replacePartView(index, newPartView);
            });

            newPartView.loadModel3D(that.cache.getCache(file));
        }
    }
};

CaseWorldView.prototype.replacePartView  = function(index, newPartView) {
    var that = this;

    var partView = that.elementViews['part'][index];

    that.scene.remove(partView.getModel3D());

    delete that.elementViews['part'][index];

    that.elementViews['part'][index] = newPartView;

    that.scene.add(newPartView.getModel3D());
};

CaseWorldView.prototype.getLoadedModelsCache = function() {
    return this.cache;
};

CaseWorldView.prototype.getPartIdByCategory = function(category, on) {
    var that = this;
    var model;
    var id;
    if(on) {
       that.elementViews[on].getPartViews().forEach(function(view) {
           model = view.getModel();
           if(model.category === category) {
               id = model.id;
           }
       });
    }else {
        that.iterateElementViews(function(view, partType) {

            if(partType !== 'part') {
                view.getPartViews().forEach(function(partView) {
                    model = partView.getModel();
                    if(model.category === category){
                        id = model.id;
                    }
                });
            }else{
                model = view.getModel();

                if(model.category === category) {
                    id = model.id;
                }
            }
        });
    }

    if(!id) {
        id = that.getModel()._invisibleParts[category];
    }

    return id;
};

CaseWorldView.prototype.setInvisiblePart = function(category, partId) {
    this.getModel()._invisibleParts[category] = partId;

    return this;
};






// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/CaseWorldView.js